// USES getVariantIdFromUrl() and GdcAddCaseToCart() in global.js

function handleCaseSelector() {
  const selectors = document.querySelectorAll('.gdc-product-quantity-option')
  const atcButton = document.querySelector('[gdc-js-add-to-cart]')

  function handleSelection(event) {
    const selected = event.target

    selectors.forEach((selector) => selector.classList.remove('active'))
    selected.classList.add('active')
  }

  function handleCaseAddToCart(event) {
    event.preventDefault()
    event.stopPropagation()

    const quantityInput = parseInt(document.querySelector('[data-js-quantity]').value)
    const caseSelected = document.querySelector('.gdc-product-quantity-option.active')
    const caseSize = parseInt(caseSelected.dataset.caseSize)
    const productId = atcButton.dataset.productId
    const selectedVariantId = getVariantIdFromUrl()
    const totalToAdd = caseSize * quantityInput

    const items = [
      {
        id: selectedVariantId ? selectedVariantId : productId,
        quantity: totalToAdd,
        properties: {
          '_Is case': 'true',
        },
      },
    ]

    GdcAddCaseToCart(items)
  }

  selectors.forEach((selector) => selector.addEventListener('click', handleSelection))
  atcButton.addEventListener('click', handleCaseAddToCart)
}

window.addEventListener('DOMContentLoaded', handleCaseSelector)
